export const serializeUser = (user) => {
  if (!user) return null;

  return {
    uid: user.uid ?? null,
    email: user.email ?? null,
    userEmail: user.email ?? null,
    phoneNumber: user.phoneNumber ?? null,
    displayName: user.displayName ?? null,
    photoURL: user.photoURL ?? null,
    emailVerified: Boolean(user.emailVerified),
  };
};
